<script setup lang="ts">
import { useSourceNavigation } from '~/composables/useSourceNavigation'
import { useInitializations } from '~/composables/initializations'
import IconSearch from '@/assets/icons/search.svg'

const {
  navigation,
  activeLevelOne,
  activeLevelTwo,
  levelTwoExists,
  getLevelOnePath,
  getLevelTwoPath,
} = useSourceNavigation()

useInitializations()
</script>

<template>
  <div class="relative">
    <nav
      aria-label="Main Navigation"
      data-testid="desktop-navigation"
      class="border-b-2 border-t-2 border-s-200"
    >
      <div class="flex justify-center">
        <div
          class="relative flex max-w-content-container grow justify-between px-4 navigation-adjustment:justify-center navigation-adjustment:gap-x-5"
        >
          <NavigationLink
            v-for="link in navigation"
            :key="link.href"
            data-testid="level-one-link"
            :to="getLevelOnePath(link)"
            :is-active="link === activeLevelOne"
            :data-active="link === activeLevelOne"
          >
            {{ link.name }}
          </NavigationLink>

          <div class="absolute right-0 top-1/2 mx-auto -translate-y-1/2 px-5">
            <div class="flex items-center justify-end gap-4">
              <LinkOrAnchor to="/search">
                <IconSearch />
              </LinkOrAnchor>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <nav
      v-if="levelTwoExists"
      aria-label="Sub Navigation"
      data-testid="desktop-subnavigation"
      class="border-b-2 border-s-200"
    >
      <div class="flex justify-center">
        <div class="mx-3 flex gap-5">
          <NavigationLink
            v-for="link in activeLevelOne.children"
            :key="link.href"
            data-testid="level-two-link"
            :to="getLevelTwoPath(link)"
            :is-active="link === activeLevelTwo"
            :data-active="link === activeLevelTwo"
          >
            {{ link.name }}
          </NavigationLink>
        </div>
      </div>
    </nav>
  </div>
</template>
